module.exports = require("inquirer");


//////////////////
// WEBPACK FOOTER
// external "inquirer"
// module id = 45
// module chunks = 0